import { useSwrNoAuth } from "../swr/useSwrNoAuth";

export const useFetchMembershipRank = (restaurantId: string, lineId: string) => {
  const { data: rank, error, isLoading: isLoadingRank } = useSwrNoAuth<string>(`membership/restaurants/${restaurantId}/line-accounts/${lineId}/membership-rank/`)
  return { rank, isLoadingRank, error };
};